import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { SesionService } from '../services/sesion.service';
import { Router } from '@angular/router';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private sesionService: SesionService) {}
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (!req.url.includes('geoserviciospruebas')) {
            const token = this.sesionService.token;
            if (token != null) {
                const authReq = req.clone({
                    headers: req.headers.set('Authorization', token),
                });
                return next.handle(authReq);
            }
        }
        return next.handle(req);
    }
}
